module.exports = __webpack_public_path__ + "static/media/wood-bgs.ae090566.png";